
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  AdvancedFilterNames,
  BaseFilterNames,
  CodeSalesPointDto,
  MarketWithSalePoints,
  RevaluationQueueFilterSelectBoxes,
  SelectBox,
  SelectMarket,
  TaskInfoCalc,
} from '@/interfaces/global-data';
import {
  AssortmentDateRequest,
  CodeSalesPointsFilters,
  GetTaskInfo,
  RevaluationQueueFilters,
  RevaluationQueueItem,
  RevertRevaluationItem,
  TaskInfoFilterType
} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import Toast from '@/mixins/toast';
import {BvModalEvent, BvTableCtxObject} from 'bootstrap-vue';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import LocalData from '../mixins/local-data';
import MarketSelect from './MarketSelect.vue';
import MultiSelect from './MultiSelect.vue';
import Card from '@/components/UI/Card.vue';
import CollapseCard from "@/components/UI/CollapseCard.vue";
import MultipleSelectFilter from "@/components/UI/Table/MultipleSelectFilter.vue";
import FilterIcon from "@/components/UI/Table/FilterIcon.vue";
import {isValidNumberValue} from "@/utils/utils";
import moment from 'moment';

type FilterOptionsKeyType = {
    [K in keyof RevaluationQueueFilterSelectBoxes]-?: RevaluationQueueFilterSelectBoxes[K] extends Array<SelectBox<number>> ? K : never
}[keyof RevaluationQueueFilterSelectBoxes];

type SelectedFilterOptionsKeyType = {
    [K in keyof RevaluationQueueFilters]-?: RevaluationQueueFilters[K] extends Array<number> ? K : never
}[keyof RevaluationQueueFilters];

@Component({
    components: {
        CollapseCard,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        Card,
        MultipleSelectFilter,
        FilterIcon
    },
    computed: {
        isValidNumberValue() {
            return isValidNumberValue;
        }
    },
    methods: {
        addLineBreaks(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/;/g, ';\n')
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class RevaluationQueue extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly isSent!: boolean
    @Prop() readonly showSalesPointsButton: boolean = false
    @Prop() readonly showSetDateButton: boolean = false
    @Prop() readonly isHistoryTab!: boolean

    privateColumnsToShowOptions = [
        {text: this.$t('regular.columns.currentRegularPrice') as string, value: 'regularPrice'},
        {text: this.$t('regular.columns.lastPriceMargin') as string, value: 'marginLastPrice'},
        {text: this.$t('regular.columns.newPrice') as string, value: 'newPrice'},
        {text: this.$t('regular.columns.promoPrice') as string, value: 'promoPrice'},
        {text: this.$t('regular.columns.newMargin') as string, value: 'newMarginPc'},
        {text: this.$t('regular.columns.priceChangePercent') as string, value: 'priceDiffPc'},
        {text: this.$t('regular.columns.newPriceHistory') as string, value: 'newPriceHistory'},
        {text: this.sentDateLabel, value: 'sentDate'},
        {text: this.$t('regular.columns.detailedStatus') as string, value: 'detailedStatus'},
    ]
    columnsVisibilityModal: boolean = false
    setCustomSendingDateModal: boolean = false
    setPriceActivationTimeModal: boolean = false
    showAssortmentLoadDateModal: boolean = false
    showRevertConfirmationModal: boolean = false
    showMainFilters: boolean = true;
    revertToAssortmentDate: string = '';
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    selectMarket: SelectMarket | null = null;

    showSalePointsByTradingIdModal: boolean = false;
    // tslint:disable-next-line: no-non-null-assertion
    tradingWithSalePoints: MarketWithSalePoints = {
        market: {
            id: (this.selectMarket ? this.selectMarket!.id : -1),
            tradingName: '',
            isDefault: false,
        }, codeSalePoints: []
    };
    // tslint:disable-next-line: no-non-null-assertion
    tradingWithSalePointsForSearch: MarketWithSalePoints = {
        market: {
            id: (this.selectMarket ? this.selectMarket!.id : -1),
            tradingName: '',
            isDefault: false,
        }, codeSalePoints: []
    };
    isAllTradingPointsSelected: boolean = false;
    showDeletedRevaluationQueueItems: boolean = false;
    currentTradingSalePoints: CodeSalesPointDto[] = [];
    commonTradingSalePoints: CodeSalesPointDto[] = [];
    loadedEmptyCheckedSalePointsByTradingId: boolean = false;

    searchString: string = ''
    defaultFilterOptionString: Array<SelectBox<string>> = [{value: 'All', label: this.$t('regular.common.all') as string}]
    defaultFilterOptionNumber: Array<SelectBox<number>> = [{value: -1, label: this.$t('regular.common.all') as string}]
    selectedFilterOptions: RevaluationQueueFilters = this.getEmptySelectedFilters()
    selectedCodeSalesPointFilterOptions: CodeSalesPointsFilters = this.getEmptyCodeSalesPointFilters()
    availableFilterOptions: RevaluationQueueFilterSelectBoxes = this.getEmptyFilterOptions()
    codeSalesPointFormats: Array<SelectBox<string>> = []
    codeSalesPointRegions: Array<SelectBox<string>> = []
    codeSalesPointClusters: Array<SelectBox<string>> = []
    salePointsFiltersLoading: boolean = false
    salePoint: string | null = null
    onDropdownClosed: Function | null = null;
    dropDownOpen = false;

    filterDropdownsRange: any = {
        from: {},
        to: {},
    };
    filterAllCheckboxCheckedState: any = {};

    waiting: boolean = false

    /** Игнорируем устаревшие ответы при быстрых повторных запросах очереди */
    private revaluationQueueListFetchGeneration = 0
    savingSalePoints: boolean = false

    tableKey: number = 1;
    resultDetailReportPerPage: number = 200
    resultDetailReportCurrentPage: number = 1
    detailReportTotalRows: number = 0

    tableFilters: Record<string, string[]> = {}

    customSendingDateFromModal: string = ''

    priceActivationTimeFromModal: any = null

    tableData: RevaluationQueueItem[] = []
    itemsForRollback: RevaluationQueueItem[] = []
    excludedRollbackItems: RevaluationQueueItem[] = [];

    isIndeterminateRollbackRevaluation: boolean = false
    isCheckedRollbackRevaluation: boolean = false

    isExportButtonLoading: boolean = false

    fullRevaluationQueueList: RevaluationQueueItem[] = []

    disableRecalculateQueueButton: boolean = false
    disableRevertRevaluationButton: boolean = false
    showRecalcQueueProgressBar: boolean = false

    priceDiffPcRange: { from: number | null; to: number | null } = {
      from: null,
      to: null
    }

    availableHasEmptyPriceDiffPc: boolean = false
    availableHasEmptyDetailedStatus: boolean = false

    selectColumnsModalCheckboxData: {
        revaluationQueue: string[],
        revaluationHistory: string[],
    } = {
        revaluationQueue: [],
        revaluationHistory: [],
    };

    columnsToShow: {
        revaluationQueue: string[],
        revaluationHistory: string[],
    } = {
        revaluationQueue: [],
        revaluationHistory: [],
    };

    salePoints = [
        {
            dataIndex: 'isIncluded',
            fixed: 'left',
            sorter: false,
            scopedSlots: {
                customRender: 'isIncluded',
                title: 'isIncludedTitle',
            }
        },
        {
            dataIndex: 'codeSalesPoint',
            title: this.$t('regular.columns.storeNumber') as string,
            sorter: (a: any, b: any) => {
                const aVal = String((a && a.codeSalesPoint) || '').trim();
                const bVal = String((b && b.codeSalesPoint) || '').trim();
                const aIsNum = /^\d+$/.test(aVal);
                const bIsNum = /^\d+$/.test(bVal);
                if (aIsNum && bIsNum) {
                    return Number(aVal) - Number(bVal);
                }
                if (aIsNum !== bIsNum) {
                    return aIsNum ? -1 : 1;
                }
                return aVal.localeCompare(bVal, undefined, { numeric: true, sensitivity: 'base' });
            },
            width: 250,
            scopedSlots: {
                filterDropdown: 'codeSalesPointFilter',
                filterIcon: 'codeSalesPointFilterIcon'
            },
            ellipsis: true
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('regular.columns.format') as string,
            sorter: (a: any, b: any) => String((a && a.storeFormat) || '').localeCompare(String((b && b.storeFormat) || ''), undefined, { numeric: true, sensitivity: 'base' }),
            scopedSlots: {
                filterDropdown: 'storeFormatFilter',
                filterIcon: 'storeFormatFilterIcon'
            },
            ellipsis: true
        },
        {
            dataIndex: 'storeRegion',
            title: this.$t('regular.columns.region') as string,
            sorter: (a: any, b: any) => String((a && a.storeRegion) || '').localeCompare(String((b && b.storeRegion) || ''), undefined, { numeric: true, sensitivity: 'base' }),
            scopedSlots: {
                filterDropdown: 'storeRegionFilter',
                filterIcon: 'storeRegionFilterIcon'
            },
            ellipsis: true
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('regular.columns.cluster') as string,
            sorter: (a: any, b: any) => String((a && a.storeCluster) || '').localeCompare(String((b && b.storeCluster) || ''), undefined, { numeric: true, sensitivity: 'base' }),
            scopedSlots: {
                filterDropdown: 'storeClusterFilter',
                filterIcon: 'storeClusterFilterIcon'
            },
            ellipsis: true
        },
    ]

    regularDetailReport = [
        {
            key: 'isIncluded',
            label: '',
            stickyColumn: true,
            sortable: false,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [this.isSent ? 'd-none' : ''],
        },
        {
            key: 'taskId',
            label: this.$t('regular.columns.reportNumber') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'userName',
            label: this.$t('regular.columns.user') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'senderUserName',
            label: this.$t('regular.columns.sender') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'cartName',
            label: this.$t('regular.columns.cartName') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'taskType',
            label: this.$t('regular.columns.calculationType') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'groupName',
            label: this.$t('regular.columns.productGroup') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'categoryName',
            label: this.$t('regular.columns.productCategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'subcategoryName',
            label: this.$t('regular.columns.productSubcategory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'formatName',
            label: this.$t('regular.columns.formatChannel') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'regionName',
            label: this.$t('regular.columns.storeRegion') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'clusterName',
            label: this.$t('regular.columns.storeCluster') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'internalCode',
            label: this.$t('regular.columns.internalCode') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'batchNumber',
            label: this.$t('regular.columns.batchNumber') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'skuName',
            label: this.$t('regular.columns.skuName') as string,
            stickyColumn: true,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: [],
        },
        {
            key: 'regularPrice',
            label: this.$t('regular.columns.currentRegularPrice') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['regularPrice'],
        },
        {
            key: 'marginLastPrice',
            label: this.$t('regular.columns.lastPriceMarginFull') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['marginLastPrice'],
        },
        {
            key: 'newPrice',
            label: this.$t('regular.columns.newPrice') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['newPrice'],
        },
        {
            key: 'promoPrice',
            label: this.$t('regular.columns.promoPrice') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['promoPrice'],
        },
        {
            key: 'newMarginPc',
            label: this.$t('regular.columns.newMargin') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['newMarginPc'],
        },
        {
            key: 'priceDiffPc',
            label: this.$t('regular.columns.priceChangePercent') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['priceDiffPc'],
        },
        {
            key: 'newPriceHistory',
            label: this.$t('regular.columns.newPriceHistory') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['newPriceHistory'],
        },
        {
            key: 'sentDate',
            label: this.sentDateLabel,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['sentDate'],
        },
        {
            key: 'customSendingDate',
            label: this.$t('regular.columns.setDate') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['cropped-custom-sending-date-text'],
            class: [this.isSent ? 'd-none' : ''],
        },
        {
            key: 'priceActivationTime',
            label: this.$t('regular.columns.priceActivationTime') as string,
            sortable: true,
            thAttr: this.thAttrTitle,
            thClass: ['croppedText'],
            class: ['priceActivationTime'],
        },
    ];

    pagination: any = {
        current: 1,
        pageSize: 20,
    };

    newRegularDetailReport: any[] = [
        {
            dataIndex: 'isIncluded',
            sorter: false,
            width: 50,
            scopedSlots: {
                customRender: 'isIncluded',
                title: 'isIncludedTitle'
            },
            fixed: this.isSent ? undefined : 'left',
        },
        {
          dataIndex: 'selectedForRollback',
          sorter: false,
          width: 50,
          scopedSlots: {
            customRender: 'selectedForRollback',
            title: 'selectedForRollbackTitle'
          },
          fixed: this.isHistoryTab ? 'left' : undefined
        },
        {
            dataIndex: 'taskId',
            title: this.$t('regular.columns.reportNumber') as string,
            sorter: true,
            width: 170,
            scopedSlots: {
                customRender: 'taskId',
                filterDropdown: 'taskIdFilter',
                filterIcon: "taskIdFilterIcon"
            },
            fixed: 'left',
        },
        {
            dataIndex: 'userName',
            title: this.$t('regular.columns.user') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'userName',
                filterDropdown: 'userNameFilter',
                filterIcon: "userNameFilterIcon"
            }
        },
        {
            dataIndex: 'senderUserName',
            title: this.$t('regular.columns.sender') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'senderUserName',
                filterDropdown: 'senderUserNameFilter',
                filterIcon: "senderUserNameFilterIcon"
            }
        },
        {
            dataIndex: 'cartName',
            title: this.$t('regular.columns.cartName') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'cartName',
                filterDropdown: 'cartNameFilter',
                filterIcon: 'cartNameFilterIcon'
            }
        },
        {
            dataIndex: 'taskType',
            title: this.$t('regular.columns.calculationType') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'taskType',
                filterDropdown: 'taskTypeFilter',
                filterIcon: 'taskTypeFilterIcon'
            }
        },
        {
            dataIndex: 'groupName',
            width: 200,
            title: this.$t('regular.columns.productGroup') as string,
            sorter: true,
            scopedSlots: {
                customRender: 'groupName',
                filterDropdown: 'groupNameFilter',
                filterIcon: "groupNameFilterIcon"
            }
        },
        {
            dataIndex: 'categoryName',
            title: this.$t('regular.columns.productCategory') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'categoryName',
                filterDropdown: 'categoryNameFilter',
                filterIcon: "categoryNameFilterIcon"
            }
        },
        {
            dataIndex: 'subcategoryName',
            title: this.$t('regular.columns.productSubcategory') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'subcategoryName',
                filterDropdown: 'subcategoryNameFilter',
                filterIcon: "subcategoryNameFilterIcon"
            }
        },
        {
            dataIndex: 'formatName',
            title: this.$t('regular.columns.formatChannel') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'formatName',
                filterDropdown: 'formatNameFilter',
                filterIcon: "formatNameFilterIcon"
            }
        },
        {
            dataIndex: 'regionName',
            title: this.$t('regular.columns.storeRegion') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'regionName',
                filterDropdown: 'regionNameFilter',
                filterIcon: "regionNameFilterIcon"
            }
        },
        {
            dataIndex: 'clusterName',
            title: this.$t('regular.columns.storeCluster') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'clusterName',
                filterDropdown: 'clusterNameFilter',
                filterIcon: "clusterNameFilterIcon"
            }
        },
        {
            dataIndex: 'internalCode',
            title: this.$t('regular.columns.internalCode') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'internalCode',
                filterDropdown: 'internalCodeFilter',
                filterIcon: "internalCodeFilterIcon"
            }
        },
        {
            dataIndex: 'batchNumber',
            title: this.$t('regular.columns.batchNumber') as string,
            width: 200,
            sorter: true,
            scopedSlots: {
                customRender: 'batchNumber',
                filterDropdown: 'batchNumberFilter',
                filterIcon: "batchNumberFilterIcon"
            }
        },
        {
            dataIndex: 'skuName',
            title: this.$t('regular.columns.skuName') as string,
            width: 300,
            sorter: true,
            scopedSlots: {
                customRender: 'skuName',
                filterDropdown: 'skuNameFilter',
                filterIcon: "skuNameFilterIcon"
            }
        },
    ];

        afterColumnsLoaded() {
          this.updateColumns();

          this.selectColumnsModalCheckboxData[this.revaluationTypeName] = JSON.parse(
              JSON.stringify(this.columnsToShow[this.revaluationTypeName])
          );

          if (
              this.$revaluation.selectMarket === undefined ||
              this.$revaluation.selectMarket.id === -1
          ) {
            return;
          }

          this.selectMarket = this.$revaluation.selectMarket;
          this.initTask();
          this.getFilters(this.selectMarket.id);
          this.loadAllCodeSalesPointByTradingId(this.selectMarket.id);
        }

        updateColumns() {
            [
                "regularPrice",
                "marginLastPrice",
                "newPrice",
                "promoPrice",
                "newMarginPc",
                "priceDiffPc",
                "newPriceHistory",
                "sentDate",
                "customSendingDate",
                "priceActivationTime",
                "detailedStatus",
            ].forEach((field) => {
                this.newRegularDetailReport = this.newRegularDetailReport.filter(i => i.dataIndex !== field)
            })

            if (this.columnsToShow[this.revaluationTypeName].includes('regularPrice')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'regularPrice',
                    width: 200,
                    title: this.$t('regular.columns.currentRegularPrice') as string,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'regularPrice',
                        filterDropdown: 'regularPriceFilter',
                        filterIcon: "regularPriceFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('marginLastPrice')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'marginLastPrice',
                    width: 200,
                    title: this.$t('regular.columns.lastPriceMarginFull') as string,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'marginLastPrice',
                        filterDropdown: 'marginLastPriceFilter',
                        filterIcon: "marginLastPriceFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('newPrice')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'newPrice',
                    title: this.$t('regular.columns.newPrice') as string,
                    width: 200,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'newPrice',
                        filterDropdown: 'newPriceFilter',
                        filterIcon: "newPriceFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('promoPrice')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'promoPrice',
                    title: this.$t('regular.columns.promoPrice') as string,
                    width: 200,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'promoPrice',
                        filterDropdown: 'promoPriceFilter',
                        filterIcon: "promoPriceFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('newMarginPc')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'newMarginPc',
                    title: this.$t('regular.columns.newMargin') as string,
                    width: 200,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'newMarginPc',
                        filterDropdown: 'newMarginPcFilter',
                        filterIcon: "newMarginPcFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('priceDiffPc')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'priceDiffPc',
                    title: this.$t('regular.columns.priceChangePercent') as string,
                    width: 200,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'priceDiffPc',
                        filterDropdown: 'priceDiffPcFilter',
                        filterIcon: "priceDiffPcFilterIcon"
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('newPriceHistory')) {
                // @ts-ignore
                this.newRegularDetailReport.push({
                    dataIndex: 'newPriceHistory',
                    title: this.$t('regular.columns.newPriceHistory') as string,
                    width: 300,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'newPriceHistory'
                    }
                })
            }
            if (this.columnsToShow[this.revaluationTypeName].includes('sentDate')) {
                this.newRegularDetailReport.push({
                    title: this.$t('regular.columns.sendDate') as string,
                    dataIndex: 'sentDate',
                    width: 150,
                    sorter: true,
                    scopedSlots: {
                        customRender: 'sentDate',
                        filterDropdown: 'sentDateFilter',
                        filterIcon: "sentDateFilterIcon"
                    }
                })
            }
            this.newRegularDetailReport.push({
                dataIndex: 'customSendingDate',
                width: this.isSent ? 0 : 200,
                title: this.isSent ? '' : this.$t('regular.columns.setDate') as string,
                sorter: !this.isSent,
                scopedSlots: {
                    customRender: 'customSendingDate',
                    filterDropdown: 'customSendingDateFilter',
                    filterIcon: "customSendingDateFilterIcon"
                }
            })
            this.newRegularDetailReport.push({
                dataIndex: 'priceActivationTime',
                width: 200,
                title: this.$t('regular.columns.priceActivationTime') as string,
                sorter: true,
                scopedSlots: {
                    customRender: 'priceActivationTime'
                }
            })
            if (!this.isSent && this.columnsToShow[this.revaluationTypeName].includes('detailedStatus')) {
                this.newRegularDetailReport.push({
                    dataIndex: 'detailedStatus',
                    width: 200,
                    title: this.$t('regular.columns.detailedStatus') as string,
                    sorter: false,
                    scopedSlots: {
                        customRender: 'detailedStatus',
                        filterDropdown: 'detailedStatusFilter',
                        filterIcon: 'detailedStatusFilterIcon'
                    }
                })
            }
        }

    mounted() {
      const stored = localStorage.getItem("revaluationColumnsToShow");
      const revaluationColumnsToShow = stored ? JSON.parse(stored) : {};

      if (revaluationColumnsToShow[this.revaluationTypeName]) {
        this.columnsToShow[this.revaluationTypeName] = revaluationColumnsToShow[this.revaluationTypeName]
            .split(",")
            .map((item: string) => item.trim())
            .filter((item: string) => !this.isSent || item !== 'detailedStatus');

        this.afterColumnsLoaded();
      } else {
        this.getColumnsToShowFromServer().then((columns) => {
          this.columnsToShow[this.revaluationTypeName] = this.isSent
              ? columns.filter((item) => item !== 'detailedStatus')
              : columns;
          this.afterColumnsLoaded();
        });
      }
    }

    created() {
        const json = this.isHistoryTab ? localStorage.getItem('revaluationHistoryTrading') : localStorage.getItem('revaluationQueueTrading');
        if (json != null) {
            this.$revaluation.selectMarket = JSON.parse(json);
            this.selectMarket = JSON.parse(json);
        }
    }

    get filteredPriceDiffPcs(): SelectBox<number>[] {
      const from = this.priceDiffPcRange.from;
      const to = this.priceDiffPcRange.to;

      return this.availableFilterOptions.priceDiffPcs.filter(opt => {
        const value = opt.value;
        if (from != null && value < from) return false;
        if (to != null && value > to) return false;
        return true;
      });
    }

    get priceDiffPcAllChecked(): boolean {
      const all = this.filteredPriceDiffPcs.map(opt => opt.value);
      const selected = this.selectedFilterOptions.priceDiffPcs || [];

      if (selected.length !== all.length) return false;

      const selectedSet = new Set(selected);
      return all.every(v => selectedSet.has(v));
    }

    //сеттер, не удалять если подсвечивается серым. Используется в фильтре по проценту изменения цены
    set priceDiffPcAllChecked(checked: boolean) {
      if (checked) {
        this.selectedFilterOptions.priceDiffPcs = this.filteredPriceDiffPcs.map(opt => opt.value);
      } else {
        this.selectedFilterOptions.priceDiffPcs = [];
      }
    }

    get sentDateLabel(): string {
        return this.$t('regular.columns.sendDate') as string;
    }

    get availableColumnsToShow(): Array<{ text: string; value: string }> {
        if (this.isSent) {
            return this.privateColumnsToShowOptions.filter((column) => column.value !== 'detailedStatus');
        }
        return this.privateColumnsToShowOptions;
    }

    get revaluationTypeName(): 'revaluationHistory' | 'revaluationQueue' {
        return this.isHistoryTab ? 'revaluationHistory' : 'revaluationQueue';
    }

    get isGroupsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$revaluation.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get isCategoriesSelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$revaluation.categoriesOfProduct);
        return categories != null && categories.length > 0;
    }

    get isSubcategorySelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$revaluation.subcategories);
        return categories != null && categories.length > 0;
    }

    get isFormatSelected(): boolean {
        const formats = LocalData.filterNumberArrays(this.$revaluation.formatSelected);
        return formats != null && formats.length > 0;
    }

    get isRegionsSelected(): boolean {
        const regions = LocalData.filterNumberArrays(this.$revaluation.regionSelected);
        return regions != null && regions.length > 0;
    }

    get isIndeterminate(): boolean {
        const count = this.tableData.filter((item) => item.isIncluded).length
        return count !== 0 && count !== this.tableData.length
    }

    get isChecked(): boolean {
        const count = this.tableData.filter((item) => item.isIncluded).length
        return count === this.tableData.length
    }

  get today(): Date {
    const today = new Date()
    today.setDate(today.getDate())
    return today
  }

    saveRevaluationParam() {
        this.getFilters(this.selectMarket!.id)
        this.refreshDetailTable()
    }

    updateProductGroup(groupOfProduct: number[]) {
        if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$revaluation.groupsOfProduct)) {
            this.$revaluation.groupsOfProduct = groupOfProduct;
            this.resetData(TaskInfoFilterType.group);
            this.saveRevaluation();
        } else if (this.$revaluation.groupsOfProduct[0] === 0) {
            this.$revaluation.groupsOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductCategory(categories: number[]) {
        if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$revaluation.categoriesOfProduct)) {
            this.$revaluation.categoriesOfProduct = categories;
            this.resetData(TaskInfoFilterType.category);
            this.saveRevaluation();
        } else if (this.$revaluation.categoriesOfProduct[0] === 0) {
            this.$revaluation.categoriesOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateFormats(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$revaluation.formatSelected)) {
            this.$revaluation.formatSelected = list;
            this.resetData(TaskInfoFilterType.format);
            this.saveRevaluation();
        } else if (this.$revaluation.formatSelected[0] === 0) {
            this.$revaluation.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$revaluation.regionSelected)) {
            this.$revaluation.regionSelected = list;
            this.resetData(TaskInfoFilterType.region);
            this.saveRevaluation();
        } else if (this.$revaluation.regionSelected[0] === 0) {
            this.$revaluation.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateClusters(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$revaluation.clusterSelected)) {
            this.$revaluation.clusterSelected = list;
            this.resetData(TaskInfoFilterType.cluster);
            this.saveRevaluation();
        } else if (this.$revaluation.clusterSelected[0] === 0) {
            this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null;
            }
        }
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$revaluation.subcategories)) {
            this.$revaluation.subcategories = list;
            this.resetData(TaskInfoFilterType.subcategory);
            this.saveRevaluation();
        } else if (this.$revaluation.subcategories[0] === 0) {
            this.$revaluation.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$revaluation.productSegments)) {
            this.$revaluation.productSegments = list;
            this.resetData(TaskInfoFilterType.p_segemnt);
            this.saveRevaluation();
        } else if (this.$revaluation.productSegments[0] === 0) {
            this.$revaluation.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    resetData(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$revaluation.categoriesOfProduct = [];
                this.$revaluation.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);

                this.taskInfo.categoryOptions = [];
                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];

                Promise.all([
                    this.getCategoryInfo(),
                    this.loadProductsSubcategories(),
                    this.getFormatInfo(),
                    this.getRegionInfo(),
                    this.getClusterInfo()
                ]);
                break;
            case TaskInfoFilterType.category:
                this.$revaluation.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);

                this.taskInfo.subcategories = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];

                Promise.all([
                  this.loadProductsSubcategories(),
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ]);
                break;
            case TaskInfoFilterType.subcategory:
                this.$revaluation.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);

                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];

                Promise.all([
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ]);
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$revaluation.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.storeFormatOptions = [];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];
                Promise.all([
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ]);
                break;
            case TaskInfoFilterType.format:
                this.$revaluation.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);

                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [];

                Promise.all([
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ]);
                break;
            case TaskInfoFilterType.region:
                this.$revaluation.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.clusterOptions = [];

                this.getClusterInfo();
                break;
        }
    }

    getCategoryInfo(cb: any = null) {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.groupSelectedRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfo.categoryOptions.unshift();
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    loadProductsGroup() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.groupOfProductRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfo.groupsOfProduct.unshift({value: 0, label: this.$t('regular.common.all') as string});
            })
            .catch((e) => {
            })
      }

    getRegionInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
      }

    getFormatInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.formatSelectedRef as any).toggleLoading(false);
                }, 500);
                this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });

            })
            .catch((e) => {
            });
      }

    getClusterInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
        }

    selectData(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$revaluation.seasonSelected.length === 0 || (this.$revaluation.seasonSelected.length === 1 && this.$revaluation.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$revaluation.seasonSelected)!!;
        const selectRegions: number[] = (this.$revaluation.regionSelected.length === 0 || (this.$revaluation.regionSelected.length && this.$revaluation.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$revaluation.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$revaluation.buyerSegmentsList.length === 0 || (this.$revaluation.buyerSegmentsList.length && this.$revaluation.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$revaluation.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$revaluation.formatSelected.length === 0 || (this.$revaluation.formatSelected.length && this.$revaluation.formatSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$revaluation.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    setSelectedAllSalePoints(allSelected: boolean) {
        if (allSelected) {
            this.tradingWithSalePoints.market = this.selectMarket ? this.selectMarket : {id: -1, tradingName: '', isDefault: false}
            this.tradingWithSalePoints.codeSalePoints = [...this.currentTradingSalePoints.map((it) => it.codeSalesPoint)]
        } else {
            this.tradingWithSalePoints.market = this.selectMarket ? this.selectMarket : {id: -1, tradingName: '', isDefault: false}
            this.tradingWithSalePoints.codeSalePoints = []
        }
    }


    get disableSaveSalePoints(): boolean {
      return this.tradingWithSalePoints.codeSalePoints.length === 0;
    }

    get disableRecalculateQueue(): boolean {
      return this.disableRecalculateQueueButton
    }

    get disableRevertRevaluation(): boolean {
      return this.disableRevertRevaluationButton
    }

    initTask() {
        if (this.$revaluation.selectMarket.id === -1) {
            return;
        }

        this.$revaluation.categoriesOfProduct = [];
        this.$revaluation.clusterSelected = [];
        this.$revaluation.formatSelected = [];
        this.$revaluation.regionSelected = [];
        this.$revaluation.groupsOfProduct = [];
        this.$revaluation.subcategories = [];
        this.$revaluation.productSegments = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        Promise.all([
            this.getCategoryInfo(),
            this.loadProductsGroup(),
            this.loadProductsSubcategories(),
            this.getFormatInfo(),
            this.getRegionInfo(),
            this.getClusterInfo()
        ]);
    }

    salePointSearch() {
        if (this.salePoint === '') {
            this.commonTradingSalePoints = this.currentTradingSalePoints;
        } else {
            this.commonTradingSalePoints = this.currentTradingSalePoints.filter((it) => this.salePoint !== null && it.codeSalesPoint.includes(this.salePoint))
        }
    }

    loadProductsSubcategories() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.subcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            })
        }

    onPriceDiffRangeChanged() {
      const validValues = new Set(this.filteredPriceDiffPcs.map(opt => opt.value));
      this.selectedFilterOptions.priceDiffPcs = this.selectedFilterOptions.priceDiffPcs
          .filter(val => validValues.has(val));
    }

    private resetPriceDiffPcFilter() {
      this.selectedFilterOptions.priceDiffPcs = [];
      this.selectedFilterOptions.includeEmptyPriceDiffPc = false;
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$revaluation.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$revaluation.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.$revaluation.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.$revaluation.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.$revaluation.clusterSelected,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private thAttrTitle(value: any, key: any, item: any, type: any) {
        const fieldDef = this.regularDetailReport.find((field) => field.key === key);

        if (fieldDef != null) {
            return {title: fieldDef.label}
        } else {
            return {}
        }
    }

    private clearFilters() {
      this.waiting = true;

      this.selectedFilterOptions = this.getEmptySelectedFilters();

      this.isCheckedRollbackRevaluation = false;
      this.isIndeterminateRollbackRevaluation = false;

      this.itemsForRollback = [];
      this.excludedRollbackItems = [];

      this.tableData.forEach(item => {
        item.selectedForRollback = false;
      });

      const pager = { ...this.pagination };
      pager.current = 1;
      this.pagination = pager;

      this.getList({}, () => {});
    }

    private disableExportButton(): boolean {
      return this.selectMarket == null
    }

    private getEmptyCodeSalesPointFilters() {
        return {
            codeSalesPoints: [],
            formatNames: [],
            regionNames: [],
            clusterNames: [],
        }
    }

    private getEmptySelectedFilters(): RevaluationQueueFilters {
      return {
        taskIds: [],
        taskTypes: [],
        userNames: [],
        senderUserNames: [],
        groupNames: [],
        categoryNames: [],
        subcategoryNames: [],
        formatNames: [],
        regionNames: [],
        clusterNames: [],
        internalCodes: [],
        batchNumbers: [],
        cartNames: [],
        skuNames: [],
        regularPrices: [],
        marginLastPrices: [],
        newPrices: [],
        promoPrices: [],
        newMarginPcs: [],
        priceDiffPcs: [],
        includeEmptyPriceDiffPc: false,
        sentDates: [],
        customSendingDates: [],
        detailedStatuses: [],
        includeEmptyDetailedStatus: false,
      };
    }

    private getEmptyFilterOptions(): RevaluationQueueFilterSelectBoxes {
      return {
        taskIds: [],
        taskTypes: [],
        userNames: [],
        senderUserNames: [],
        groupNames: [],
        categoryNames: [],
        subcategoryNames: [],
        formatNames: [],
        regionNames: [],
        clusterNames: [],
        internalCodes: [],
        batchNumbers: [],
        cartNames: [],
        skuNames: [],
        regularPrices: [],
        marginLastPrices: [],
        newPrices: [],
        promoPrices: [],
        newMarginPcs: [],
        priceDiffPcs: [],
        sentDates: [],
        customSendingDates: [],
        detailedStatuses: [],
      };
    }

    private changeTaskIdFilter(selected: any[]) {
        this.changeFilter('taskIds', selected)
    }

    private changeTaskTypeFilter(selected: any[]) {
        this.changeFilter('taskTypes', selected)
    }

    private changeUserFilter(selected: any[]) {
        this.changeFilter('userNames', selected)
    }

    private changeSenderUserFilter(selected: any[]) {
        this.changeFilter('senderUserNames', selected)
    }

    private changeGroupFilter(selected: any[]) {
        this.changeFilter('groupNames', selected)
    }

    private changeCategoryFilter(selected: any[]) {
        this.changeFilter('categoryNames', selected)
    }

    private changeSubcategoryFilter(selected: any[]) {
        this.changeFilter('subcategoryNames', selected)
    }

    private changeFormatFilter(selected: any[]) {
        this.changeFilter('formatNames', selected)
    }

    private changeRegionFilter(selected: any[]) {
        this.changeFilter('regionNames', selected)
    }

    private changeClusterFilter(selected: any[]) {
        this.changeFilter('clusterNames', selected)
    }

    private changeInternalCodeFilter(selected: any[]) {
        this.changeFilter('internalCodes', selected)
    }

    private changeBatchNumberFilter(selected: any[]) {
        this.changeFilter('batchNumbers', selected)
    }

    private changeDetailedStatusFilter(selected: any[]) {
        this.changeFilter('detailedStatuses', selected)
    }

    private resetDetailedStatusFilter() {
        this.selectedFilterOptions.detailedStatuses = [];
        this.selectedFilterOptions.includeEmptyDetailedStatus = false;
    }

    private changeCartNameFilter(selected: any[]) {
        this.changeFilter('cartNames', selected)
    }

    private changeSkuNameFilter(selected: any[]) {
        this.changeFilter('skuNames', selected)
    }

    private changeRegularPriceFilter(selected: any[]) {
        this.changeFilter('regularPrices', selected)
    }

    getFilterOptions(filterModel: string, filterOptionsKey: FilterOptionsKeyType) {
        return this.availableFilterOptions[filterOptionsKey].filter((option: SelectBox<number>) => {
            if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                return option.value >= this.filterDropdownsRange.from[filterModel];
            } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                return option.value <= this.filterDropdownsRange.to[filterModel];
            } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
            } else {
                return true;
            }
        })
    }

    handleAllCheckboxChanged(value: boolean, filterModel: string, filterOptionsKey: FilterOptionsKeyType, variableName: SelectedFilterOptionsKeyType) {
        this.filterAllCheckboxCheckedState[filterModel] = value;

        if (value) {
            this.selectedFilterOptions[variableName] = [
                ...new Set([
                    ...this.selectedFilterOptions[variableName],
                    ...this.getFilterOptions(filterModel, filterOptionsKey).map((option: SelectBox<number>) => option.value),
                ])
            ];
        } else {
            const optionValuesToDeselect = this.getFilterOptions(filterModel, filterOptionsKey).map((option: SelectBox<number>) => option.value);

            this.selectedFilterOptions[variableName] = this.selectedFilterOptions[variableName].filter((value: number) => !optionValuesToDeselect.includes(value));
        }
    }

    private changeMarginLastPriceFilter(selected: any[]) {
        this.changeFilter('marginLastPrices', selected)
    }

    private changeNewPriceFilter(selected: any[]) {
        this.changeFilter('newPrices', selected)
    }

    private changePromoPriceFilter(selected: any[]) {
        this.changeFilter('promoPrices', selected)
    }

    private changeNewMarginPcFilter(selected: any[]) {
        this.changeFilter('newMarginPcs', selected)
    }

    private changePriceDiffPcFilter(selected: any[]) {
        this.changeFilter('priceDiffPcs', selected)
    }

    private changeSentDateFilter(checkedValues: string[]) {
        this.changeFilter('sentDates', checkedValues)
        if (this.isSent) {
            this.changeFilter('customSendingDates', checkedValues)
        }
    }

    private changeCustomSendingDateFilter(selected: any[]) {
        this.changeFilter('customSendingDates', selected)
    }

    private changeSalePointsFilters(val: any, field: string, tableFilterKey: string, callback: Function) {
      // @ts-ignore
      this.selectedCodeSalesPointFilterOptions[field] = val;
      callback(tableFilterKey, val);
    }

  private changeFilter(
      fieldName: keyof RevaluationQueueFilters,
      selected: (string | number)[]
  ) {
    if (!Array.isArray(selected)) return;

    const arr = this.selectedFilterOptions[fieldName];
    if (!Array.isArray(arr)) return;

    if (selected.includes(-1) || selected.includes('All')) {
      arr.splice(0, arr.length);
      return;
    }

    (arr as (string | number)[]).splice(0, arr.length, ...selected);
  }

    private changeTableFilter(name: string, selected: any) {
        this.tableFilters[name] = selected

        this.commonTradingSalePoints = this.currentTradingSalePoints.filter((point) =>
            Object.entries(this.tableFilters).every(([key, value]: [string, any]) =>
                key === "codeSalesPoint" ?
                    point[key as keyof CodeSalesPointDto].includes(value as string) || value.length <= 0
                    :
                    value.includes(point[key as keyof CodeSalesPointDto]) || value.length <= 0
            )
        );
    }

    onTableChange(pagination: any, _: any, sorter: any) {
        this.waiting = true;
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;

        this.getList({
            sortBy: sorter.field,
            sortDesc: sorter.order === 'descend'
        }, () => {});
    }

    private getBaseFilters(): BaseFilterNames {

        return {
            groupsOfProduct: this.taskInfo.groupsOfProduct.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.groupsOfProduct.includes(it.value)).map((it) => it.label),
            categories: this.taskInfo.subcategories.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.categoriesOfProduct.includes(it.value)).map((it) => it.label),
            subcategories: this.taskInfo.subcategories.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.subcategories.includes(it.value)).map((it) => it.label),
            storeFormat: this.taskInfo.storeFormatOptions.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.formatSelected.includes(it.value)).map((it) => it.label),
            storeRegionValues: this.taskInfo.storeRegionOptions.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.regionSelected.includes(it.value)).map((it) => it.label),
            storeCluster: this.taskInfo.clusterOptions.filter((it) => it.value != null && it.value !== 0 && this.$revaluation.clusterSelected.includes(it.value)).map((it) => it.label),
        }
    }

  private getAdvancedFilters(): AdvancedFilterNames {
    return {
      taskIds: this.selectedFilterOptions.taskIds,
      taskTypes: this.selectedFilterOptions.taskTypes,
      userNames: this.selectedFilterOptions.userNames,
      senderUserNames: this.selectedFilterOptions.senderUserNames,
      internalCodes: this.selectedFilterOptions.internalCodes,
      skuNames: this.selectedFilterOptions.skuNames,
      regularPrices: this.selectedFilterOptions.regularPrices,
      marginLastPrices: this.selectedFilterOptions.marginLastPrices,
      newPrices: this.selectedFilterOptions.newPrices,
      promoPrices: this.selectedFilterOptions.promoPrices,
      newMarginPcs: this.selectedFilterOptions.newMarginPcs,
      priceDiffPcs: this.selectedFilterOptions.priceDiffPcs,
      includeEmptyPriceDiffPc: this.selectedFilterOptions.includeEmptyPriceDiffPc,
      sentDates: this.selectedFilterOptions.sentDates,
      customSendingDates: this.selectedFilterOptions.customSendingDates,
      detailedStatuses: this.selectedFilterOptions.detailedStatuses,
      includeEmptyDetailedStatus: this.selectedFilterOptions.includeEmptyDetailedStatus,
      showExcludedProducts: this.showDeletedRevaluationQueueItems
    }
  }

  private getList(ctx: Partial<BvTableCtxObject>, callback: (items: RevaluationQueueItem[]) => void) {
    const fetchGeneration = ++this.revaluationQueueListFetchGeneration;
    const params = this.getParamsForFetchingRevaluationQueue(ctx);

    this.httpGetRevaluationQueue(params)
        .then((r) => {
          if (fetchGeneration !== this.revaluationQueueListFetchGeneration) {
            return;
          }
          const pagination = { ...this.pagination };
          pagination.total = r.data.totalElements;
          this.pagination = pagination;

          this.detailReportTotalRows = r.data.totalElements;

          if (this.showDeletedRevaluationQueueItems) {
            this.tableData = r.data.content;
          } else {
            this.tableData = r.data.content.filter(item => item.isIncluded);
          }

          this.tableData.forEach(item => {

            if (this.isCheckedRollbackRevaluation) {
              const excluded = this.excludedRollbackItems.some(ex =>
                  this.isSameRollbackItem(ex, item)
              );

              item.selectedForRollback = !excluded;

            } else {
              item.selectedForRollback = this.itemsForRollback.some(i =>
                  this.isSameRollbackItem(i, item)
              );
            }
          });

          callback(this.tableData);

          this.updateHeaderCheckboxState();

          this.getFilters(this.selectMarket!.id);
        })
        .catch(() => {
          if (fetchGeneration !== this.revaluationQueueListFetchGeneration) {
            return;
          }
          this.showError(this.$t('regular.errors.loadReportListFailed') as string);
          callback([]);
        })
        .finally(() => {
          if (fetchGeneration === this.revaluationQueueListFetchGeneration) {
            this.waiting = false;
          }
        });
  }

  private exportRevaluationQueue(ctx: Partial<BvTableCtxObject>) {
        this.isExportButtonLoading = true
        this.httpGetRevaluationQueueFile(this.getParamsForFetchingRevaluationQueue(ctx))
            .then((response) => {
              let extension = '.csv'
              let dateString = moment().format('YYYYMMDD_HHmmss')
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute(
                  'download',
                  this.$t('regular.files.revaluationQueue') as string + this.selectMarket!!.tradingName + '_' + dateString + extension
              );

              document.body.appendChild(link);
              link.click();
            })
            .finally(() => {
              this.isExportButtonLoading = false
            })
    }

    private applyBaseFiltersToSelectedFilterOptions(): void {
      const baseFilters = this.getBaseFilters()

      if (baseFilters.groupsOfProduct.length > 0 && this.selectedFilterOptions.groupNames.length === 0) {
        this.selectedFilterOptions.groupNames = baseFilters.groupsOfProduct
      }

      if (baseFilters.categories.length > 0 && this.selectedFilterOptions.categoryNames.length === 0) {
        this.selectedFilterOptions.categoryNames = baseFilters.categories
      }

      if (baseFilters.subcategories.length > 0 && this.selectedFilterOptions.subcategoryNames.length === 0) {
        this.selectedFilterOptions.subcategoryNames = baseFilters.subcategories
      }

      if (baseFilters.storeFormat.length > 0 && this.selectedFilterOptions.formatNames.length === 0) {
        this.selectedFilterOptions.formatNames = baseFilters.storeFormat
      }

      if (baseFilters.storeRegionValues.length > 0 && this.selectedFilterOptions.regionNames.length === 0) {
        this.selectedFilterOptions.regionNames = baseFilters.storeRegionValues
      }

      if (baseFilters.storeCluster.length > 0 && this.selectedFilterOptions.clusterNames.length === 0) {
        this.selectedFilterOptions.clusterNames = baseFilters.storeCluster
      }
    }

    private getParamsForFetchingRevaluationQueue(ctx: Partial<BvTableCtxObject>) {
      this.applyBaseFiltersToSelectedFilterOptions()

      const sortBy = ctx && ctx.sortBy ? ctx.sortBy : 'taskId';
      const sortDesc = ctx && ctx.sortDesc ? 1 : 0;

      return {
        page: this.pagination.current - 1,
        size: this.pagination.pageSize,
        sort: {fieldName: sortBy, sortValue: sortDesc},
        tradingId: this.selectMarket!.id,
        isSent: this.isSent,
        searchString: this.searchString,
        filters: this.selectedFilterOptions,
        showExcludedProducts: this.showDeletedRevaluationQueueItems,
      }
    }

    private getFilters(tradingNetworkId: number) {
      this.httpGetRevaluationQueueFilters(
          tradingNetworkId,
          this.isSent,
          this.getBaseFilters(),
          this.getAdvancedFilters()
      ).then((r) => {
        const oldOptions = this.availableFilterOptions;
        const newFilterOptions = this.getEmptyFilterOptions();

        // Поля, которые нужно сортировать
        const sortableKeys = [
          'taskIds',
          'taskTypes',
          'groupNames',
          'categoryNames',
          'subcategoryNames',
          'formatNames',
          'regionNames',
          'clusterNames',
          'cartNames',
          'regularPrices',
          'marginLastPrices',
          'newPrices',
          'newMarginPcs',
          'priceDiffPcs',
          'sentDates',
          'customSendingDates',
          'detailedStatuses',
        ];

        // Поля, где сортировка должна идти по числовому value
        const numericKeys = [
          'regularPrices',
          'marginLastPrices',
          'newPrices',
          'newMarginPcs',
          'priceDiffPcs',
          'sentDates',
          'customSendingDates'
        ];

        Object.entries(newFilterOptions).forEach(([key, value]) => {
          if (key === 'hasEmptyPriceDiffPc' || key === 'hasEmptyDetailedStatus') {
            return;
          }

          const selectedValues = this.selectedFilterOptions[key as keyof RevaluationQueueFilters];
          const serverValues = (r.data as RevaluationQueueFilters)[key as keyof RevaluationQueueFilters] || [];

          // Если фильтр уже выбран — оставляем старые опции
          if (Array.isArray(selectedValues) && selectedValues.length > 0) {
            newFilterOptions[key as keyof RevaluationQueueFilterSelectBoxes] =
                oldOptions[key as keyof RevaluationQueueFilterSelectBoxes];
            return;
          }

          // Формируем список SelectBox
          if (key === 'sentDates' || key === 'customSendingDates') {
            (serverValues as string[]).forEach((valueFromServer) => {
              value.push({ value: valueFromServer, label: this.formatDate(valueFromServer) })
            })
          } else if (key === 'taskTypes') {
            (serverValues as string[]).forEach((valueFromServer) => {
              value.push({
                value: valueFromServer,
                label: this.$t('backendValues.taskTypes.' + valueFromServer) as string
              })
            })
          } else {
            (serverValues as (string | number)[]).forEach((valueFromServer) => {
              value.push({ value: valueFromServer, label: String(valueFromServer) })
            })
          }

          // Сортировка, если поле в списке sortableKeys
          if (sortableKeys.includes(key)) {
            (value as Array<SelectBox<string | number>>).sort(
                (a: SelectBox<string | number>, b: SelectBox<string | number>) => {
                  if (key === 'sentDates' || key === 'customSendingDates') {
                    return Date.parse(String(a.value)) - Date.parse(String(b.value))
                  }
                  if (numericKeys.includes(key)) return Number(a.value) - Number(b.value)
                  return a.label.localeCompare(b.label, 'ru', { sensitivity: 'base' })
                }
            )
          }
        });

        // Убираем дубликаты по label только для дат
        const removeDuplicatesByLabel = (items: SelectBox<string>[]): SelectBox<string>[] => {
          const seen = new Set<string>()
          return items.filter(item => !seen.has(item.label) && !!seen.add(item.label))
        };

        if (this.selectedFilterOptions.sentDates.length === 0) {
          newFilterOptions.sentDates = removeDuplicatesByLabel(newFilterOptions.sentDates);
        }

        if (this.selectedFilterOptions.customSendingDates.length === 0) {
          newFilterOptions.customSendingDates = removeDuplicatesByLabel(newFilterOptions.customSendingDates);
        }

        if (!this.selectedFilterOptions.includeEmptyPriceDiffPc) {
          this.availableHasEmptyPriceDiffPc = !!(r.data as RevaluationQueueFilters).hasEmptyPriceDiffPc;
        }

        if (!this.selectedFilterOptions.includeEmptyDetailedStatus) {
          this.availableHasEmptyDetailedStatus = !!(r.data as RevaluationQueueFilters).hasEmptyDetailedStatus;
        }

        this.availableFilterOptions = newFilterOptions;
      });
    }

    private getColumnsToShowFromServer(): Promise<string[]> {
        return this.httpGetRevaluationQueueColumns().then((r) => {
            return r.data;
        }).catch(() => {
            return [];
        })
    }

    private saveColumns() {
        this.httpSaveRevaluationQueueColumns(this.selectColumnsModalCheckboxData[this.revaluationTypeName]).then((r) => {
            const revaluationColumnsToShow = localStorage.getItem("revaluationColumnsToShow") ? JSON.parse(localStorage.getItem("revaluationColumnsToShow") as string) : {};
            revaluationColumnsToShow[this.revaluationTypeName] = this.selectColumnsModalCheckboxData[this.revaluationTypeName].toString();
            localStorage.setItem('revaluationColumnsToShow', JSON.stringify(revaluationColumnsToShow));

            this.columnsToShow[this.revaluationTypeName] = JSON.parse(JSON.stringify(this.selectColumnsModalCheckboxData[this.revaluationTypeName]));

            this.updateColumns();
        })
    }

    private resetColumnsVisibility(columns: string[]) {
        // this.columns.visible = columns
        // this.columns.toShow = columns
        // this.$emit('changeColumns', this.columns)
        // const dNone = 'd-none'
        //
        // this.availableColumnsToShow.map((c) => c.value).forEach((column) => {
        //     Array.from(document.getElementsByClassName(column))
        //             .forEach((c) => c.classList.add(dNone))
        // })
        // this.columns.visible.forEach((column) => {
        //     Array.from(document.getElementsByClassName(column))
        //             .forEach((c) => c.classList.remove(dNone))
        // })

        // const table = [ ...this.fullRegularDetailReport.splice(0,13) ];
        // this.availableColumnsToShow.map((c) => c.value).forEach((column) => {
        //     const field = this.fullRegularDetailReport.find(i => i.dataIndex === column);
        //     if (field) table.push(field);
        //
        //
        //     // const classes = this.regularDetailReport.filter((c) => c.key === column)[0].class as string[]
        //     // const dNoneIndex = classes.findIndex((c) => c === dNone)
        //     // const columnIndex = this.columns.visible.findIndex((c) => c === column)
        //     //
        //     // if (dNoneIndex === -1 && columnIndex === -1) {
        //     //     classes.push('d-none')
        //     // } else if (dNoneIndex > -1 && columnIndex > -1) {
        //     //     const classIndex = classes.findIndex((c) => c === dNone)
        //     //     if (classIndex > -1) {
        //     //         classes.splice(classIndex, 1)
        //     //     }
        //     // }
        // })
        // table.push(this.fullRegularDetailReport[20])
        // this.newRegularDetailReport = table
        // this.availableColumnsToShow.map((c) => c.value).forEach((column) => {
        //     const classes = this.regularDetailReport.filter((c) => c.key === column)[0].class as string[]
        //     const dNoneIndex = classes.findIndex((c) => c === dNone)
            // const columnIndex = this.columns.visible.findIndex((c) => c === column)

            // if (dNoneIndex === -1 && columnIndex === -1) {
            //     classes.push('d-none')
            // } else if (dNoneIndex > -1 && columnIndex > -1) {
            //     const classIndex = classes.findIndex((c) => c === dNone)
            //     if (classIndex > -1) {
            //         classes.splice(classIndex, 1)
            //     }
            // }
        // })
    }

    private updateSelectMarket(market: SelectMarket) {
        this.selectMarket = market
        this.resetRevaluationData();
        this.selectedFilterOptions = this.getEmptySelectedFilters();
        this.$revaluation.selectMarket = market
        this.initTask();
        this.getFilters(market.id)
        this.loadAllCodeSalesPointByTradingId(market.id)
        this.refreshDetailTable()
        this.saveRevaluation();
        this.resultDetailReportCurrentPage = 1
        this.isHistoryTab ? localStorage.setItem('revaluationHistoryTrading', JSON.stringify(market)) : localStorage.setItem('revaluationQueueTrading', JSON.stringify(market));
    }

    private loadCheckedSalePointsByTradingId() {
      this.tradingWithSalePointsForSearch = {
        market: this.selectMarket!,
        codeSalePoints: this.currentTradingSalePoints.map((it) => it.codeSalesPoint),
      };

      return this.httpGetRevaluationCheckedSalesPointsByTradingId(this.tradingWithSalePointsForSearch)
          .then((r) => {
            this.tradingWithSalePoints = {
              market: this.selectMarket!,
              codeSalePoints: r.data,
            };
            this.loadedEmptyCheckedSalePointsByTradingId = false;
            if (r.data.length === 0) {
              this.loadedEmptyCheckedSalePointsByTradingId = true;
              this.currentTradingSalePoints.map((it) => it.codeSalesPoint).forEach((value) => {
                this.tradingWithSalePoints.codeSalePoints.push(value);
              });
            }
          })
          .catch((e) => {
            this.showError(this.$t('regular.errors.loadStoresForTcFailed') as string);
            throw e;
          });
    }

    private isSelectedSalePoint(salePointName: string): boolean {
        const index = this.tradingWithSalePoints.codeSalePoints.findIndex((name) => {
            return name === salePointName
        });
        return index !== -1;
    }

    private setSelectedSalePoint(salePointName: string, change: boolean) {
        const salePointIndex = this.tradingWithSalePoints.codeSalePoints.findIndex((item) => {
            return item === salePointName
        });
        if (change) {
            if (salePointIndex === -1) {
                this.tradingWithSalePoints.codeSalePoints.push(salePointName)
            }
        } else {
            if (salePointIndex !== -1) {
                this.tradingWithSalePoints.codeSalePoints.splice(salePointIndex, 1)
            }
        }
    }

    private setShowDeletedItems(isDeleted: boolean) {
        this.showDeletedRevaluationQueueItems = isDeleted
    }

    private saveCheckedSalePointsByTradingId() {
      if (this.tradingWithSalePoints.codeSalePoints.length === 0) {
        return;
      }
      this.savingSalePoints = true;
      this.httpSaveTradingsAndSalePoints(this.tradingWithSalePoints)
          .then(() => {
            this.showInfo(this.$t('regular.notifications.tcParamsSaved') as string);
            this.loadedEmptyCheckedSalePointsByTradingId = false;
            return this.loadCheckedSalePointsByTradingId();
          })
          .then(() => {
            this.showSalePointsByTradingIdModal = false;
          })
          .catch(() => {
            this.showError(this.$t('regular.errors.loadStoresForCompanyFailed') as string);
          })
          .finally(() => {
            this.savingSalePoints = false;
          });
    }

    private saveSelectedByInternalCodeProduct(taskId: number, internalCode: string, isIncluded: boolean) {
        if (this.selectMarket == null || this.selectMarket.id === -1) {
            return
        }
        this.waiting = true
        this.httpSaveSelectedByInternalCodeRevaluationQueueProducts(this.selectMarket.id, taskId, internalCode, isIncluded)
                .then(() => this.refreshDetailTable())
                .catch(() => this.waiting = false)
    }

    // private updateSelectedRollbackItems(item: RevaluationQueueItem, selected: boolean) {
    //   const index = this.itemsForRollback.findIndex(existing => this.isSameRollbackItem(existing, item));
    //   if (selected && index === -1) {
    //     this.itemsForRollback.push(item);
    //   } else if (!selected && index !== -1) {
    //     this.itemsForRollback.splice(index, 1);
    //   }
    // }

    private updateSelectedRollbackItemChecked(item: RevaluationQueueItem, selected: boolean) {

      if (this.isCheckedRollbackRevaluation) {
        // Если глобальный чекбокс включён (выбраны ВСЕ элементы)

        if (!selected) {
          // Пользователь снял галку с одного элемента → добавляем в исключения
          this.excludedRollbackItems.push(item);
          this.isIndeterminateRollbackRevaluation = true;
        } else {
          // Пользователь вернул галку обратно → убираем исключение
          this.excludedRollbackItems = this.excludedRollbackItems.filter(ex =>
              !this.isSameRollbackItem(ex, item)
          );
        }

      } else {

        // Обычный режим (глобальное выбрано=false)
        const index = this.itemsForRollback.findIndex(existing =>
            this.isSameRollbackItem(existing, item)
        );

        if (selected && index === -1) {
          this.itemsForRollback.push(item);
        } else if (!selected && index !== -1) {
          this.itemsForRollback.splice(index, 1);
        }
      }

      // Обновляем локальный флаг
      item.selectedForRollback = selected;

      this.updateHeaderCheckboxState();
    }

    private updateSelectedRollbackItemsByFilter(checked: boolean) {

      this.isCheckedRollbackRevaluation = checked;
      this.isIndeterminateRollbackRevaluation = false;

      if (checked) {
        // "Выбраны все"
        this.itemsForRollback = [];          // индивидуальные выборы не нужны
        this.excludedRollbackItems = [];     // нет исключений

        // отмечаем текущую страницу только визуально
        this.tableData.forEach(item => item.selectedForRollback = true);

      } else {
        // "Снять выбор со всех"
        this.itemsForRollback = [];
        this.excludedRollbackItems = [];

        this.tableData.forEach(item => item.selectedForRollback = false);
      }
    }

    private updateHeaderCheckboxState() {

      if (this.isCheckedRollbackRevaluation) {
        // выбраны все страницы
        this.isIndeterminateRollbackRevaluation =
            this.excludedRollbackItems.length > 0;
        return;
      }

      // обычный режим
      const page = this.tableData;
      const selected = page.filter(i => i.selectedForRollback).length;

      this.isCheckedRollbackRevaluation =
          selected === page.length && page.length > 0;

      this.isIndeterminateRollbackRevaluation =
          selected > 0 && selected < page.length;
    }

    private applyRollbackFromStore() {
      this.tableData.forEach(item => {
        item.selectedForRollback = this.itemsForRollback.some(i =>
            this.isSameRollbackItem(i, item)
        );
      });
    }

    private isSameRollbackItem(a: RevaluationQueueItem, b: RevaluationQueueItem): boolean {
      return a.taskId === b.taskId && a.internalCode === b.internalCode;
    }

    private saveSelectedByFilterProducts(isIncluded: boolean) {
        if (this.selectMarket == null || this.selectMarket.id === -1) {
            return
        }
        this.waiting = true
        this.tableData.forEach((item) => item.isIncluded = isIncluded);
        this.httpSaveSelectedByFiltersRevaluationQueueProducts(
                this.selectedFilterOptions,
                this.selectMarket.id,
                isIncluded,
        )
                .then(() => this.refreshDetailTable())
                .catch(() => this.waiting = false)
    }

  private saveCustomSendingDate(taskId: number, internalCode: string, dateStr: string) {
    const customSendingDateStr = dateStr === '' ? null : dateStr
    this.httpSaveRevaluationCustomSendingDate(taskId, internalCode, customSendingDateStr)
        .then(() => this.showInfo(this.$t('regular.notifications.setDateSaved') as string))
  }

  private onTaskIdChange(e: any) {
    const val = e.target.value ? e.target.value.trim() : null;
    this.selectedFilterOptions.taskIds = val ? [Number(val)] : [];
  }

  private resetTaskIdFilter(clearFilters: () => void) {
    this.selectedFilterOptions.taskIds = [];
    clearFilters();
  }

  private applyTaskIdFilter(confirm: () => void, clearFilters: () => void) {
    const val = this.selectedFilterOptions.taskIds[0];
    if (!val || isNaN(val)) {
      this.selectedFilterOptions.taskIds = [];
      clearFilters();
    } else {
      confirm();
    }
  }

  private resetFormatIdFilter(clearFilters: () => void) {
    this.selectedFilterOptions.formatNames = [];
    clearFilters();
  }

  private onSkuNameChange(e: any) {
    const val = e.target.value ? e.target.value.trim() : null;
    this.selectedFilterOptions.skuNames = val ? [val] : [];
  }

  private resetSkuNameFilter(clearFilters: () => void) {
    this.selectedFilterOptions.skuNames = [];
    clearFilters();
  }

  private applySkuNameFilter(confirm: () => void, clearFilters: () => void) {
    const val = this.selectedFilterOptions.skuNames[0];
    if (!val) {
      this.selectedFilterOptions.skuNames = [];
      clearFilters();
    } else {
      confirm();
    }
  }

  private onChangeCustomSendingDateModal(date: string) {
      this.customSendingDateFromModal = date
  }

  private onChangeRevertToAssortmentDate(date: string) {
      this.revertToAssortmentDate = date
  }

  private saveCustomSendingDateModal() {
      this.saveCustomSendingDateBroadcast({});
  }

  private saveCustomSendingDateBroadcast(ctx: Partial<BvTableCtxObject>) {
    const baseFilters = this.getBaseFilters()

    if (baseFilters.groupsOfProduct.length > 0 && this.selectedFilterOptions.groupNames.length === 0) {
      this.selectedFilterOptions.groupNames = baseFilters.groupsOfProduct
    }

    if (baseFilters.categories.length > 0 && this.selectedFilterOptions.categoryNames.length === 0) {
      this.selectedFilterOptions.categoryNames = baseFilters.categories
    }

    if (baseFilters.subcategories.length > 0 && this.selectedFilterOptions.subcategoryNames.length === 0) {
      this.selectedFilterOptions.subcategoryNames = baseFilters.subcategories
    }

    if (baseFilters.storeFormat.length > 0 && this.selectedFilterOptions.formatNames.length === 0) {
      this.selectedFilterOptions.formatNames = baseFilters.storeFormat
    }

    if (baseFilters.storeRegionValues.length > 0 && this.selectedFilterOptions.regionNames.length === 0) {
      this.selectedFilterOptions.regionNames = baseFilters.storeRegionValues
    }

    if (baseFilters.storeCluster.length > 0 && this.selectedFilterOptions.clusterNames.length === 0) {
      this.selectedFilterOptions.clusterNames = baseFilters.storeCluster
    }

    const params = {
      page: -1,
      size: -1,
      sort: {fieldName: ctx.sortBy || 'taskId', sortValue: ctx.sortDesc ? 1 : 0},
      tradingId: this.selectMarket!.id,
      isSent: this.isSent,
      searchString: this.searchString,
      filters: this.selectedFilterOptions,
      showExcludedProducts: false,
    }

    this.waiting = true

    const dateStr = this.customSendingDateFromModal === '' ? null : this.customSendingDateFromModal
    this.httpSaveRevaluationCustomSendingDateBroadcast(params, dateStr)
        .then(() => {
          this.showInfo(this.$t('regular.notifications.setDateSaved') as string)
          this.getList(ctx, () => {})
        })
        .finally(() => {
          this.waiting = false
        })
  }

  private savePriceActivationTimeModal() {
      this.savePriceActivationTimeBroadcast({});
  }

  private savePriceActivationTimeBroadcast(ctx: Partial<BvTableCtxObject>) {
    if (this.priceActivationTimeFromModal == null) {
      return
    }

    this.applyBaseFiltersToSelectedFilterOptions()

    const params = {
      page: -1,
      size: -1,
      sort: {fieldName: ctx.sortBy || 'taskId', sortValue: ctx.sortDesc ? 1 : 0},
      tradingId: this.selectMarket!.id,
      isSent: this.isSent,
      searchString: this.searchString,
      filters: this.selectedFilterOptions,
      showExcludedProducts: false,
    }

    this.waiting = true

    const priceActivationTime = moment(this.priceActivationTimeFromModal).format('YYYY-MM-DDTHH:mm:00')
    this.httpSaveRevaluationPriceActivationTimeBroadcast(params, priceActivationTime)
        .then(() => {
          this.showInfo(this.$t('regular.notifications.priceActivationTimeSaved') as string)
          this.getList(ctx, () => {})
        })
        .catch(() => undefined)
        .finally(() => {
          this.waiting = false
        })
  }

  private getStartOfTodayLocal(): Date {
    const startOfToday = new Date()
    startOfToday.setHours(0, 0, 0, 0)
    return startOfToday
  }

  private isCustomSendingDateDisabled(selectedDate: any): boolean {
    const selectedJsDate: Date | undefined = selectedDate && selectedDate._d ? selectedDate._d : undefined
    if (!selectedJsDate) return false
    return selectedJsDate < this.getStartOfTodayLocal()
  }

    private recalculateQueue() {
      this.disableRecalculateQueueButton = true
      this.showRecalcQueueProgressBar = true
      this.httpRecalculateQueue().then(
        (r)=>{
          if(r.status === 200 || r.status === 204)
            this.disableRecalculateQueueButton = false
            this.showRecalcQueueProgressBar = false
            this.refreshDetailTable()
        }
      )
        .catch((e)=>{
          this.disableRecalculateQueueButton = false
          this.showRecalcQueueProgressBar = false
        }
      )
    }

    private confirmRevertRevaluation() {
      this.applyBaseFiltersToSelectedFilterOptions();
      const selectedItems = this.getSelectedRollbackItemsForRequest();
      const itemsToRollback =
          this.isCheckedRollbackRevaluation
              ? []
              : this.mapToRevertItems(selectedItems);

      const request = {
        assortmentDate: this.revertToAssortmentDate,
        tradingId: this.selectMarket!.id,
        itemsForRollback: itemsToRollback,
        selectAll: this.isCheckedRollbackRevaluation,
        excludedItems: this.mapToRevertItems(this.excludedRollbackItems),
        filters: this.selectedFilterOptions,
        searchString: this.searchString,
      }

      this.httpRemoveRevertProductsFromRevaluationQueue(request)
          .then((r) => {
            if (r.status === 200) {
              this.revertRevaluation();
            }
          })
          .catch((exception) => {
            const status = exception.response.status;
            const data = exception.response && exception.response.data;
            const message = data && (data.message || data);

            switch (status) {
              case 400:
                this.showInfo(this.$t('regular.notifications.noItemsForRevert') as string);
                break;
              case 500:
                this.showError(this.$t('regular.errors.serverError') as string);
                break;
              default:
                this.showError(this.$t('regular.errors.unknownErrorWithDetails', { status, message }) as string);
            }
          });
    }

    private revertRevaluation() {
      // const date = new Date(this.revertToAssortmentDate)
      // this.showInfo(this.$t('revaluationQueue.messages.testRevaluationRollback', { detail: date.toLocaleString('fr-CA', {year: 'numeric', month: '2-digit', day: '2-digit'} }) as string));

      this.applyBaseFiltersToSelectedFilterOptions();
      const selectedItems = this.getSelectedRollbackItemsForRequest();
      const itemsToRollback =
          this.isCheckedRollbackRevaluation
              ? []
              : this.mapToRevertItems(selectedItems);
      const request: AssortmentDateRequest = {
        assortmentDate: this.revertToAssortmentDate,
        tradingId: this.selectMarket!.id,
        itemsForRollback: itemsToRollback,
        selectAll: this.isCheckedRollbackRevaluation,
        excludedItems: this.mapToRevertItems(this.excludedRollbackItems),
        filters: this.selectedFilterOptions,
        searchString: this.searchString,
      };

      this.httpRevertRevaluationToAssortment(request)
          .then((r) => {
            switch (r.status) {
              case 200:
                this.refreshDetailTable();
                this.showInfo(this.$t('regular.notifications.revaluationRolledBack') as string);
                break;

              default:
                const message = r.data;
                this.showError(this.$t('regular.errors.unknownErrorWithDetails', { status: r.status, message }) as string);
            }
          })
          .catch((exception) => {
            const status = exception.response.status;
            const data = exception.response && exception.response.data;
            const message = data && (data.message || data);

            switch (status) {
              case 409:
                this.disableRevertRevaluationButton = true
                this.showRevertConfirmationModal = true;
                console.log(this.showRevertConfirmationModal)
                break;
              case 400:
                this.showInfo(this.$t('regular.notifications.noItemsForRevert') as string);
                break;
              case 412:
                this.showInfo(this.$t('regular.notifications.assortmentNotFound') as string);
                break;
              case 500:
                this.showError(this.$t('regular.errors.serverError') as string);
                break;
              default:
                this.showError(this.$t('regular.errors.unknownErrorWithDetails', { status, message }) as string);
            }
          });
    }

    private mapToRevertItems(items: RevaluationQueueItem[]): RevertRevaluationItem[] {
      return items.map(item => ({
        taskId: item.taskId,
        groupName: item.groupName,
        categoryName: item.categoryName,
        subcategoryName: item.subcategoryName,
        formatName: item.formatName,
        regionName: item.regionName,
        clusterName: item.clusterName,
        internalCode: item.internalCode
      }));
    }

    private getSelectedRollbackItemsForRequest(): RevaluationQueueItem[] {
      if (this.isCheckedRollbackRevaluation) {
        return this.excludedRollbackItems;
      } else {
        return this.itemsForRollback;
      }
    }

    private unlockRevertRevaluationButton() {
      this.disableRevertRevaluationButton = false
    }

    private onCancelRevertRevaluation() {
      this.unlockRevertRevaluationButton()
      this.showRevertConfirmationModal = false
    }

    private onHideRevertConfirmationModal(bvEvent: BvModalEvent) {
      this.unlockRevertRevaluationButton()
      if (bvEvent.trigger === 'headerclose') {
        this.showRevertConfirmationModal = false
      }
    }

    private onHideAssortmentLoadDateModal(bvEvent: BvModalEvent) {
        if (bvEvent.trigger === 'headerclose') {
          this.disableRevertRevaluationButton = false
        }
    }

    private refreshDetailTable() {
        this.waiting = true;
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;

        const resultDetailReportRef = this.$refs.resultDetailReportRef as any
        if (typeof resultDetailReportRef !== 'undefined') {
            resultDetailReportRef.refresh()
        }
    }

    private formatDecimal(input: number): string {
        return String(input)
                .replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ')
                .replace('.', ',')
    }

    //Таймзону подставили хардкодом, но в идеале её нужно подгружать с бэка
    private formatDate(dateValue: string | number | null | undefined) {
      if (!dateValue) return
      const date = new Date(dateValue)
      return new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date)
    }

    // Время активации цены приходит как LocalDateTime без таймзоны — форматируем без конвертации
    private formatDateTime(dateValue: string | null | undefined) {
      if (!dateValue) return
      return moment(dateValue).format('DD.MM.YYYY HH:mm:ss')
    }

    private showSalePointsByTradingId() {
        this.showSalePointsByTradingIdModal = true;
    }

    private loadAllCodeSalesPointByTradingId(tradingNetworkId: number) {
      this.salePointsFiltersLoading = true;
      this.codeSalesPointFormats = [];
      this.codeSalesPointRegions = [];
      this.codeSalesPointClusters = [];
      this.httpGetAllSalesPointsByTradingId(tradingNetworkId)
          .then((r) => {
            this.currentTradingSalePoints = r.data;
            this.commonTradingSalePoints = this.currentTradingSalePoints;
            this.codeSalesPointFormats = [...new Set(this.currentTradingSalePoints.map((it) => it.storeFormat))]
                .filter((value): value is string => value != null && value !== '')
                .map((value) => ({ value, label: value }));
            this.codeSalesPointRegions = [...new Set(this.currentTradingSalePoints.map((it) => it.storeRegion))]
                .filter((value): value is string => value != null && value !== '')
                .map((value) => ({ value, label: value }));
            this.codeSalesPointClusters = [...new Set(this.currentTradingSalePoints.map((it) => it.storeCluster))]
                .filter((value): value is string => value != null && value !== '')
                .map((value) => ({ value, label: value }));

            this.loadCheckedSalePointsByTradingId();
          })
          .catch(() => {
            this.showError(this.$t('regular.errors.loadStoresForTcFailed') as string);
          })
          .finally(() => {
            this.salePointsFiltersLoading = false;
          });
    }
}
